import React from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {
  StyledTableFiltersSearch,
  StyledTableFilters,
  StyledTableFiltersElements,
  StyledTableFiltersLeftSideContent
} from './StyledTableFilters';

const TableFilters = ({
  onFilter,
  leftSideContent,
  rightSideContent,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const handleOnFilter = (key, value) => onFilter && onFilter({[key]: value});

  return (
    <StyledTableFilters {...rest}>
      <StyledTableFiltersElements>
        <Space size='large' align='center'>
          <StyledTableFiltersSearch
            allowClear
            onSearch={(value) => handleOnFilter('search', value)}
            placeholder={t('search')}
            size='large'
          />
          {leftSideContent && (
            <StyledTableFiltersLeftSideContent className='table-filters-left-side-content'>
              {leftSideContent}
            </StyledTableFiltersLeftSideContent>
          )}
        </Space>
        {rightSideContent && <div className='table-filters-right-side-content'>{rightSideContent}</div>}
      </StyledTableFiltersElements>
    </StyledTableFilters>
  );
}

TableFilters.propTypes = {
  leftSideContent: PropTypes.any,
  onFilter: PropTypes.func,
  rightSideContent: PropTypes.any
}

export default TableFilters;
